import React from 'react';
import classNames from 'classnames';
import SortList from '../../../components/List/SortList';
require('./ToolSortList.scss');

/*
    SortList: 排序组件
    
*/

export default class ToolSortList extends React.Component {
	constructor(props) {
		super(props);
        this.selectFields = this.selectFields.bind(this);
	}

    componentDidMount() {
        this.defaultSort = this.props.sortData ? this.props.sortData : [];
    }

    selectFields(sortSelect) {
        this.props.handleClose && this.props.handleClose();
        const { searchData } = this.props;
        let tableParam = { searchData: searchData, sortData: sortSelect };
        setTimeout(() => {
            this.props.reloadTable(tableParam,'fromSort');
        }, 300);
    }

    render() {
        return (
            <SortList activeFields={this.props.sortData}
                        defaultSort={this.defaultSort || []}
                        sortFields={this.props.sortColumns}
                        actions={this.props.actions}
                        selectFields={this.selectFields}
                        touchCancle={this.props.handleCancel}
                        handleClosePopUp={this.props.handleClosePopUp}
            />);
	}
}


// WEBPACK FOOTER //
// ./src/components/ToolsBar/ToolSortList/ToolSortList.js